// KEY-711: My Dials hides its organising tools until there is something to organise.
//
// The count is of STANDALONE dials only (the `cards` on the Dashboard): the view tools (saved view /
// group / sort / search) only act on the standalone tile grid, and GroupPicker can only offer
// standalone dials. With 0 or 1 of them there is nothing to sort or group, and a new group would be
// a group-of-one.
const MIN_DIALS_TO_ORGANISE = 2;

export function showViewTools(standaloneCount: number): boolean {
  return standaloneCount >= MIN_DIALS_TO_ORGANISE;
}

export function showNewGroup(standaloneCount: number): boolean {
  return standaloneCount >= MIN_DIALS_TO_ORGANISE;
}
